import {
  SettingsSections,
  vouchersSettings,
} from "../../Services/SettingService";

export enum IAssetsType {
  PurchaseAssets,
  Disposed,
}

export const findVoucharCustomizationTemplete = (
  settingsSections: SettingsSections,
  allVouchersSettings?: vouchersSettings[],
  assetsType?: IAssetsType
) => {
  console.log("allVouchersSettings", allVouchersSettings);
  let vouchersTypeTem;
  switch (settingsSections) {
    case SettingsSections.Invoice:
      vouchersTypeTem = allVouchersSettings?.filter(
        (x: vouchersSettings) =>
          x?.settingType === settingsSections &&
          !x.settings.invoiceSettings.showAsset
      );
      break;
    case SettingsSections.PurInvoice:
      vouchersTypeTem = allVouchersSettings?.filter(
        (x: vouchersSettings) =>
          x?.settingType === settingsSections &&
          !x.settings.billSettings.showAsset
      );
      break;
    case SettingsSections.Asset:
      if (assetsType) {
        vouchersTypeTem = allVouchersSettings?.filter(
          (x: vouchersSettings) =>
            x?.settingType === SettingsSections.Invoice &&
            !x.settings.invoiceSettings?.showRCM
        );
      } else {
        vouchersTypeTem = allVouchersSettings?.filter(
          (x: vouchersSettings) =>
            x?.settingType === SettingsSections.PurInvoice &&
            !x.settings.billSettings?.showRCM
        );
      }
      // console.log("allVouchersSettings", vouchersTypeTem);
      break;
    default:
      vouchersTypeTem = allVouchersSettings?.filter(
        (x: vouchersSettings) => x?.settingType === settingsSections
      );
      break;
  }
  return vouchersTypeTem?.map((x: vouchersSettings, index: number) => ({
    value: x?.id?.toString(),
    label: x?.title,
    key: index,
    // title: `${x?.settingType}`,
  }));
};
